import { FieldInfoGroupField } from '@app/common/configurable-wizards';

import { useSettingFieldsContext } from '@app/widgets/contacts-and-settings/contexts/SettingFieldsContext';

import { ServerSectionIds } from '../types';

export const useContactPermissions = (field: FieldInfoGroupField) => {
  const { permissions } = useSettingFieldsContext();
  const sectionId = field.id as ServerSectionIds;

  const isReadonly = permissions.readonlyGroups.includes(sectionId);
  const isMutiple = permissions.multipleFields.includes(sectionId);
  const editAllowed = !isReadonly && (isMutiple || field.subFields.length === 0);

  return {
    isReadonly,
    isMutiple,
    editAllowed,
  };
};
